/* card-swatch-swap.js - works with the theme's native radio + label swatch markup
   Listens for change events on the radios; reads data-variant-media JSON
   to swap the parent card's image; updates the card link to include ?variant=N.
*/
(function(){
  function findParent(el, selector) {
    while (el && el !== document) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentNode;
    }
    return null;
  }
  function handleSwatchChange(input) {
    if (!input || !input.matches) return;
    if (!input.matches('input[type="radio"]')) return;
    var card = findParent(input, '.product-card');
    if (!card) return;
    // Parse the variant-media JSON
    var raw = input.getAttribute('data-variant-media');
    var variantId = input.getAttribute('data-variant-id') || '';
    if (!raw) return;
    var media;
    try { media = JSON.parse(raw); }
    catch (e) { return; }
    var src = media && media.src;
    if (!src) return;
    // Normalize protocol-relative URLs
    if (src.indexOf('//') === 0) src = window.location.protocol + src;
    // Swap card's main image
    var mainImg = card.querySelector('.product-card__image--primary, .product-card__media img');
    if (mainImg) {
      mainImg.src = src;
      // build srcset
      var widths = [200, 400, 600, 800, 1000];
      var srcset = widths.map(function(w){
        return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w + ' ' + w + 'w';
      }).join(', ');
      mainImg.srcset = srcset;
    }
    // Update the card's product link
    var links = card.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (!href) continue;
      var base = href.split('?')[0];
      links[i].setAttribute('href', base + (variantId ? '?variant=' + variantId : ''));
    }
  }
  document.addEventListener('change', function(e){
    handleSwatchChange(e.target);
  }, true);
  document.addEventListener('click', function(e){
    var label = findParent(e.target, '.product-card__swatch-list label');
    if (!label) return;
    var forId = label.getAttribute('for');
    if (!forId) return;
    var input = document.getElementById(forId);
    if (input) {
      input.checked = true;
      handleSwatchChange(input);
    }
  }, true);
})();
